import ActiveCampaign from 'components/Content/BeautyInsider/BeautyInsiderModules/ActiveCampaign/ActiveCampaign';
import { withActiveCampaignProps } from 'viewModel/content/BeautyInsider/BeautyInsiderModules/ActiveCampaign/withActiveCampaignProps';

export default withActiveCampaignProps(ActiveCampaign);
